// --------------------------------------------------------------------------
// #107 – Countdown block
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

require('jquery');

module.exports = function (options) {
    var context = options.context;
    var display = context.find('[data-binding="display"]');
    var startTime = 3600; /// Seconds in 1 hour
    var remainingTime;
    var hours;
    var minutes;
    var seconds;
    var currentTime;
    var secondDecrease;
    var timerStarted = false;

    // Set button variables
    var startButton = context.find('[data-binding="start-countdown-button"]');
    var pauseButton = context.find('[data-binding="pause-countdown-button"]');
    var restartButton = context.find('[data-binding="restart-countdown-button"]');

    /**
    * Pause
    */
    function pauseTimer() {

        /// Disable the pause button
        pauseButton.prop('disabled', true);

        /// Enable the restart button
        restartButton.prop('disabled', false);

        /// Clear the stored interval
        clearInterval(secondDecrease);
    }

    /**
    * Set timer
    */
    function setTimer() {
        hours = parseInt(remainingTime / (60 * 60));
        minutes = parseInt(remainingTime / 60, 10);
        seconds = parseInt(remainingTime % 60, 10);

        hours = '0' + hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;

        display.text(hours + ':' + minutes + ':' + seconds);
    }

    /**
    * Stop
    */
    function stopTimer() {

        /// Set the time to 0
        remainingTime = 0;

        /// Clear the stored interval
        pauseTimer();

        /// Set the timer to 0:00:00
        setTimer();

        /// Disable the restart and pause buttons
        restartButton.prop('disabled', true);
    }

    /**
    * Decrement the remaining time
    * and update the countdown text
    */
    function decrementTimer() {
        // Decrease remaining time by 1
        remainingTime--;

        setTimer();

        /// If the time has decreased to 0
        if (remainingTime === 0) {
            stopTimer();
        }
    }

    /**
    * Start
    * @param  {int} duration
    */
    function startTimer(duration) {

        /// Enable the pause button
        pauseButton.prop('disabled', false);

        // Disable the restart button if it isn't already disabled
        if (!restartButton.prop('disabled')) {
            restartButton.prop('disabled', true);
        }

        /// Set the timer to the duration passed in
        remainingTime = duration;

        secondDecrease = setInterval(function () {
            decrementTimer();
        }, 1000);
    }

    startButton.on('click', function (e) {
        e.preventDefault();

        if (!timerStarted) {
            timerStarted = true;

            /// Set the text of the display
            display.text('01:00:00');

            /// Start the timer at startTime
            startTimer(startTime);

            /// Change text of start button to 'end countdown'
            startButton.find('.button__text--start-countdown').hide();
            startButton.find('.button__text--end-countdown').show();
        } else {
            timerStarted = false;
            // Stop the timer and set it to 0
            stopTimer();
            /// Change text of start button to 'start countdown'
            startButton.find('.button__text--end-countdown').hide();
            startButton.find('.button__text--start-countdown').show();
        }
    });

    pauseButton.on('click', function (e) {
        e.preventDefault();

        /// Run pause
        pauseTimer();
    });

    restartButton.on('click', function (e) {
        e.preventDefault();

        /// Set the current time to be the time paused at
        currentTime = remainingTime;

        /// Restart the timer again at currentTime
        startTimer(currentTime);
    });

    function init() {

        /// Add a restart (play) button to the page
        pauseButton.add(restartButton).prop('disabled', true);

        // Set countdown click events
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/countdown.js
// module id = 223
// module chunks = 0